import { genreOptions, regionOptions, yearOptions } from "@/mocks/films";

interface FilterPanelProps {
  genres: string[];
  year: string;
  region: string;
  onToggleGenre: (genre: string) => void;
  onYearChange: (year: string) => void;
  onRegionChange: (region: string) => void;
  onReset: () => void;
  activeCount: number;
}

function Chip({
  active,
  children,
  onClick,
}: {
  active: boolean;
  children: React.ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-8 px-3 rounded-md text-xs md:text-[13px] whitespace-nowrap transition-colors cursor-pointer border ${
        active
          ? "bg-primary-600 border-primary-600 text-background-50"
          : "bg-background-50 border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
      }`}
    >
      {children}
    </button>
  );
}

export default function FilterPanel({
  genres,
  year,
  region,
  onToggleGenre,
  onYearChange,
  onRegionChange,
  onReset,
  activeCount,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-background-200">
        <div className="flex items-center gap-2">
          <i className="ri-equalizer-line text-primary-600 w-4 h-4 flex items-center justify-center"></i>
          <span className="text-sm text-foreground-900">筛选条件</span>
          {activeCount > 0 && (
            <span className="px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 text-[11px] font-label">
              {activeCount}
            </span>
          )}
        </div>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置筛选
        </button>
      </div>

      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
          <span className="text-xs text-foreground-500 shrink-0 pt-2 w-12">类型</span>
          <div className="flex flex-wrap gap-2">
            {genreOptions.map((genre) => (
              <Chip key={genre} active={genres.includes(genre)} onClick={() => onToggleGenre(genre)}>
                {genre}
              </Chip>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
          <span className="text-xs text-foreground-500 shrink-0 pt-2 w-12">年份</span>
          <div className="flex flex-wrap gap-2">
            <Chip active={year === "全部"} onClick={() => onYearChange("全部")}>
              全部
            </Chip>
            {yearOptions.map((item) => (
              <Chip key={item} active={year === item} onClick={() => onYearChange(item)}>
                {item === "更早" ? "2020 及更早" : item}
              </Chip>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
          <span className="text-xs text-foreground-500 shrink-0 pt-2 w-12">地区</span>
          <div className="flex flex-wrap gap-2">
            <Chip active={region === "全部"} onClick={() => onRegionChange("全部")}>
              全部
            </Chip>
            {regionOptions.map((item) => (
              <Chip key={item} active={region === item} onClick={() => onRegionChange(item)}>
                {item}
              </Chip>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}